import Footer from "@/common/components/footer/Footer";
import Navbar from "@/common/components/navbar/Navbar";
import ScrollTop from "@/common/components/ScrollTop/ScrollTop";
import {
  staticFooterData,
  staticMenuData,
} from "@/common/constants/staticData";
import Image from "next/image";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Circles from "../../components/Circles";
import FullLayout from "../full-layout/FullLayout";
import CustomCursor from "@/common/components/cursor/Cursor";
import useScreenWidth from "@/hooks/useScreenWidth";
import { RootState } from "@/rematch/store/store";

interface TemplateProps {
  children: React.ReactNode;
}

export default function Template({ children }: TemplateProps) {
  const isconnected = useSelector((state: RootState) => state.auth.isconnected);
  const [footers, setFooters] = useState(staticFooterData.data);
  const [menus, setMenus] = useState(staticMenuData.data);

  const widthSize = useScreenWidth();

  const dispatch = useDispatch();
  const router = useRouter();

  // Check first visit
  useEffect(() => {
    if (typeof window !== "undefined") {
      const visitedBefore = sessionStorage.getItem("visitedBefore");
      if (!visitedBefore) {
        sessionStorage.setItem("visitedBefore", "true");
      }
    }
  }, []);

  // Get user data
  useEffect(() => {
    const getME = async () => {
      try {
        await dispatch.auth.me();
      } catch (error) {
        console.error("Failed to fetch user data:", error);
      }
    };
    getME();
  }, [dispatch.auth]);

  // Get menu and footer data
  useEffect(() => {
    const loadData = async () => {
      try {
        const [menuRes, footerRes] = await Promise.all([
          dispatch.menuModel.getMenuAsync(),
          dispatch.footerModel.getFooterAsync(),
        ]);

        if (menuRes.data?.menu?.length) {
          setMenus(menuRes.data);
        }
        if (footerRes.data?.footer?.length) {
          setFooters(footerRes.data);
        }
      } catch (error) {
        console.error("Failed to load menu/footer data:", error);
      }
    };

    loadData();
  }, [dispatch.menuModel, dispatch.footerModel]);

  // Handle i18n initialization

  const isAdminPage = router.pathname === "/admin";
  const isLoginPage = router.pathname === "/login";

  if (isAdminPage) {
    return isconnected ? (
      <FullLayout>{children}</FullLayout>
    ) : (
      <div className="position-fixed d-flex justify-content-center align-items-center start-0 end-0 top-0 bottom-0">
        <div>
          <span className="loader"></span>
        </div>
        <div>
          <h3>
            <Image
              src="/images/mas/logo.svg"
              alt="logo"
              width={200}
              height={200}
              priority
            />
          </h3>
        </div>
      </div>
    );
  }

  if (isLoginPage) {
    return <div className="">{children}</div>;
  }

  return (
    <>
      <ScrollTop />
      {widthSize && widthSize > 900 && <CustomCursor />}
      <div className="container-fluid d-flex flex-column min-vh-100 p-0">
        <Navbar items={menus?.menu} />
        <main className="flex-grow-1">{children}</main>
        <Footer items={footers?.footer} />
      </div>
    </>
  );
}
